import { CaseStatus } from '../types/enums';

/**
 * Soft tone tokens (`surface.*Soft`) — pill styling aligned to Hangar feedback soft backgrounds.
 */
export type CaseStatusFeedbackTone = 'info' | 'warning' | 'error' | 'success';

export type CaseStatusPillConfig =
    | { kind: 'feedbackSoft'; tone: CaseStatusFeedbackTone }
    | { kind: 'baseNeutral' };

export function mapCaseStatusToPillConfig(status: CaseStatus): CaseStatusPillConfig {
    switch (status) {
        case CaseStatus.PENDING:
        case CaseStatus.ON_HOLD:
            return { kind: 'feedbackSoft', tone: 'warning' };
        case CaseStatus.IN_ANALYSIS:
        case CaseStatus.TO_NOTIFY:
            return { kind: 'feedbackSoft', tone: 'info' };
        case CaseStatus.SENDING_ERROR:
            return { kind: 'feedbackSoft', tone: 'error' };
        case CaseStatus.NOTIFIED:
            return { kind: 'feedbackSoft', tone: 'success' };
        case CaseStatus.NOT_APPLICABLE:
            return { kind: 'baseNeutral' };
        default:
            return { kind: 'feedbackSoft', tone: 'info' };
    }
}
